import { hasClassificationFieldSchema } from "resha"

import { JobStatus, labelable } from "../Models/API/JobModel"
import { SuperTaskWorkerType } from "../Models/API/SuperTaskModel"
import { hasValue } from "../Models/Client/FetchState"
import { hasAppPermission } from "../Models/Client/ProjectRole"
import { useAppInstance } from "./useAppInstance"
import { useAppSuperTasks } from "./useAppSuperTasks"
import { useAssumedRoles } from "./useAssumedRoles"
import { useJobCount } from "./useJobCount"

/**
 *
 * Check for label availability on the app level
 */
export const useCanLabelApp = (
    appID: string,
    refreshJobCount = true
): { canLabel: boolean; couldLabel: boolean; labelableJobCount: number } => {
    const instanceFetch = useAppInstance(appID)
    const rolesFetch = useAssumedRoles(appID)
    const { value: superTasks } = useAppSuperTasks(appID)

    const hasCollaboratorSuperTask = !!superTasks?.some(({ workers }) =>
        workers.some(({ type }) => type === SuperTaskWorkerType.COLLABORATORS)
    )

    const couldLabel =
        hasValue(instanceFetch) && hasValue(rolesFetch)
            ? !hasClassificationFieldSchema(
                  instanceFetch?.value.outputUiSchema
              ) &&
              hasCollaboratorSuperTask &&
              hasAppPermission(rolesFetch.value, "task:label")
            : false

    const jobCount = useJobCount(
        appID,
        refreshJobCount ? { refreshInterval: 10000 } : {}
    )

    const labelableJobCount = labelable().reduce(
        (agg, s) =>
            agg + (s !== JobStatus.IN_CREATION ? jobCount?.[s] ?? 0 : 0),
        0
    )

    return {
        canLabel: couldLabel && labelableJobCount > 0,
        couldLabel,
        labelableJobCount
    }
}
